import { type FC } from 'react';

import { useCardOfferIsMulti, useCardOfferIsTop3 } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { PublisherCardLayout } from './internal/components/PublisherCardLayout/PublisherCardLayout';
import { PublisherCardLayoutCompact } from './internal/components/PublisherCardLayoutCompact';
import { PublisherCardLayoutFull } from './internal/components/PublisherCardLayoutFull';
import { type PublisherCardLayoutContainerProps } from './internal/types';

export const PublisherCardLayoutContainer: FC<PublisherCardLayoutContainerProps> = props => {
  const { avatar, type, nameWithBadges, documentsChecked, contactActions, brandingLevel } = props;
  const isCompact = useListingLayoutIsNarrowSelector();
  const isMulti = useCardOfferIsMulti();
  const isTop3 = useCardOfferIsTop3();
  const shouldDisplayAvatarForCompactLayout = isMulti || isTop3;

  let content: JSX.Element;

  if (isCompact) {
    content = (
      <PublisherCardLayoutCompact
        avatar={avatar}
        nameWithBadges={nameWithBadges}
        shouldDisplayAvatar={shouldDisplayAvatarForCompactLayout}
        type={type}
      />
    );
  } else {
    content = (
      <PublisherCardLayoutFull
        avatar={avatar}
        contactActions={contactActions}
        documentsChecked={documentsChecked}
        nameWithBadges={nameWithBadges}
        type={type}
      />
    );
  }

  return (
    <PublisherCardLayout brandingLevel={brandingLevel} isCompact={isCompact}>
      {content}
    </PublisherCardLayout>
  );
};
